import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { SERVICES } from "@/data/services";
import api from "@/lib/api";

export default function Services() {
  const { t, i18n } = useTranslation();
  const isIT = i18n.language.startsWith("it");
  const [galleries, setGalleries] = useState({});
  useEffect(() => {
    api.get("/services/gallery").then((r) => setGalleries(r.data || {})).catch(() => {});
  }, []);
  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20 lg:py-28">
      <div className="text-center">
        <h1 className="font-serif text-5xl lg:text-6xl text-stone-900" data-testid="services-title">
          {t("services.title")}
        </h1>
        <div className="mt-4 w-16 h-[2px] bg-[#D06D4D] mx-auto" aria-hidden="true" />
        <p className="mt-6 text-lg text-stone-700 max-w-2xl mx-auto">{t("services.sub")}</p>
      </div>

      <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
        {SERVICES.map((s, i) => {
          const Icon = s.icon;
          const cover = galleries[s.slug]?.[0];
          return (
            <Link
              key={s.slug}
              to={`/${s.slug}`}
              data-testid={`services-item-${i}`}
              aria-label={isIT ? s.title_it : s.title_en}
              className="group relative rounded-2xl overflow-hidden aspect-[4/5] bg-stone-800 shadow-[8px_8px_24px_rgba(28,25,23,0.12)] hover:shadow-[10px_10px_32px_rgba(28,25,23,0.18)] transition-shadow block focus:outline-none focus:ring-2 focus:ring-[#D06D4D] focus:ring-offset-2"
            >
              {cover && <img
                src={cover}
                alt=""
                aria-hidden="true"
                decoding="async"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />}
              <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/60 to-black/85 transition-opacity duration-500 group-hover:from-black/50 group-hover:via-black/70 group-hover:to-black/90" aria-hidden="true" />
              <div className="relative h-full flex flex-col justify-end p-7">
                <div className="absolute top-6 left-6 w-11 h-11 rounded-lg bg-white/10 backdrop-blur-sm border border-white/15 flex items-center justify-center transition-colors group-hover:bg-white/20">
                  <Icon size={20} className="text-white" />
                </div>
                <h3 className="font-serif text-2xl lg:text-[26px] text-white leading-tight">
                  {isIT ? s.title_it : s.title_en}
                </h3>
                <span className="mt-3 inline-flex items-center gap-1 text-xs uppercase tracking-widest text-white/85">
                  {isIT ? "Scopri" : "Discover"} <span aria-hidden="true">→</span>
                </span>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
